var React = require('react');

function SearchList (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1259","data-name":"Path 1259","d":"M1438.642,552.479h-12.6v-.823h12.6Zm-14.352-7.6h-1.627v1.68h1.627Zm14.352.473h-12.6v.823h12.6Zm-14.352,5.828h-1.627v1.679h1.627Zm0,6.3h-1.627v1.679h1.627Zm14.352.472h-12.6v.823h12.6Z","transform":"translate(-1422.663 -544.884)","fill":"#002560"}));
}

SearchList.defaultProps = {"width":"15.979","height":"14.28","viewBox":"0 0 15.979 14.28"};

module.exports = SearchList;

SearchList.default = SearchList;
